var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGym(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.25,
    y: 29.3751,
    width: 3.91667,
    height: 11.75,
    rx: 1.95833,
    transform: "rotate(-180 35.25 29.3751)",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.91667,
    height: 11.75,
    rx: 1.95833,
    transform: "matrix(1 -8.19589e-08 -9.3251e-08 -1 11.75 29.3751)",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39.1665,
    y: 33.2915,
    width: 3.91667,
    height: 19.5833,
    rx: 1.95833,
    transform: "rotate(-180 39.1665 33.2915)",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6665,
    y: 25.4585,
    width: 3.91667,
    height: 15.6667,
    transform: "rotate(-90 15.6665 25.4585)",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 3.91667,
    height: 19.5833,
    rx: 1.95833,
    transform: "matrix(1 -1.09278e-07 -6.99382e-08 -1 7.83301 33.2915)",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83317 21.5415H5.87484C4.79328 21.5415 3.9165 22.4183 3.9165 23.4998V23.4998C3.9165 24.5814 4.79328 25.4582 5.87484 25.4582H7.83317",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1663 21.5415H41.1247C42.2062 21.5415 43.083 22.4183 43.083 23.4998V23.4998C43.083 24.5814 42.2062 25.4582 41.1247 25.4582H39.1663",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGym);
export default __webpack_public_path__ + "static/media/gym.7b67b9f477375352d6320fd9e124c636.svg";
export { ForwardRef as ReactComponent };